import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
registerLocaleData(localeIt);

if (environment.type === 'prod') {
  enableProdMode();
}

if (environment.plausible) {
  // Queue stub so custom events fired before the script loads are buffered.
  window.plausible =
    window.plausible ||
    function (...args: unknown[]) {
      (window.plausible!.q = window.plausible!.q || []).push(args);
    };

  const script = document.createElement('script');
  if (environment.plausible.script) {
    // the site's own script, as Plausible's dashboard gives it: the stub above, then init()
    window.plausible.init =
      window.plausible.init ||
      function (options?: Record<string, unknown>) {
        window.plausible!.o = options || {};
      };
    window.plausible.init();
    script.async = true;
    script.src = environment.plausible.script;
  } else {
    script.defer = true;
    script.dataset['domain'] = environment.plausible.domain;
    script.src = 'https://plausible.io/js/script.js';
  }
  document.head.appendChild(script);
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
